import Button, { ButtonSize, ButtonType } from "../Button"

export interface LetsTalkProps {
  nmlsCode?: string
  heading: string
  headingMaxWidth?: number
  subhead: string
  button?: {
    size?: ButtonSize
    type?: ButtonType
    text: string
    url?: string
  }
  className?: string
  buttonClass?: string
  name: LetsTalkName
}

export interface LetsTalkPropsImg {
  src: string
  width: string
}

export enum LetsTalkName {
  Elizabeth = "elizabeth",
  Charlie = "charlie",
}
